import React from 'react'

class Search extends React.Component {
    render() {
        return (
            <div>Search page</div>
        )
    }
}

export default Search